import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { formInputTheme } from "../../textinput/styled/formInputTheme";
import { TypeRampV2 } from "../../typography";
export var SelectButtonText = styled(TypeRampV2)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    min-width: 0;\n    text-align: start;\n    color: ", ";\n"])), function (_ref) {
  var themeMode = _ref.themeMode;
  return formInputTheme.textColor.rest(themeMode);
});
//# sourceMappingURL=SelectButtonText.js.map